import { apiClient } from "../apiClient";

const DANH_SACH_DU_DIEU_KIEN_THUC_TAP_ENDPOINT = 'danh-sach-du-dieu-kien-thuc-tap';
export const danhSachDuDieuKienThucTapApi = {
    SelectByDotThucTap: (id_dot_thuc_tap: number) => apiClient.get(`${DANH_SACH_DU_DIEU_KIEN_THUC_TAP_ENDPOINT}/dot-thuc-tap/${id_dot_thuc_tap}`),
    SelectByDotThucTapChiTietDiem: (id_dot_thuc_tap: number) => apiClient.get(`${DANH_SACH_DU_DIEU_KIEN_THUC_TAP_ENDPOINT}/dot-thuc-tap/${id_dot_thuc_tap}/chi-tiet-diem`),
    ChuyenKhongDuDieuKien: (id: number) => apiClient.delete(`${DANH_SACH_DU_DIEU_KIEN_THUC_TAP_ENDPOINT}/chuyen-khong-du-dieu-kien/${id}`),
}